module.exports = __webpack_public_path__ + "img/Skateboarding.08a4c579.png";